<template>
  <div class="">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="">
        <div
          class="badge badge-status badge-status-sm"
          :style="{ 'color': item.status.color, 'background-color': $root.$helper.color.convertHex(item.status.color) }"
        >
          <span>{{ item.status.name }}</span>
        </div>
      </div>
      <div class="d-flex">
        <div class="">
          <button
            type="button"
            class="btn btn-link shadow-none text-decoration-none text-nowrap p-0 m-0"
            @click.prevent="selectFeature(item)"
          >
            <span class="text-btn-link pl-2 pl-sm-3">{{ $t(txtLinkMap) }}</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="item.type" class="title">
      {{ item.type.name }}
    </div>
    <div class="row no-gutters">
      <div class="col">
        <div class="form-group">
          <p class="label">
            {{ $t(labelCode) }}
          </p>
          <p>{{ item.code }}</p>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <p class="label">
            {{ $t(labelCreatedAt) }}
          </p>
          <p>{{ moment(item.created_at, "YYYY-MM-DD hh:mm:ss").format('DD-MM-YYYY') }}</p>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <div class="form-group">
          <p class="label">
            {{ $t(labelAddress) }}
          </p>
          <p>{{ item.address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
        name: "ItemStatusMap",
        mixins: [

        ],
        props: {
            item: {
                type: Object,
                required: true
            },
            txtLinkMap: {
                type: String,
                default: 'View on map',
            },
            labelCode: {
                type: String,
                default: 'Code',
            },
            labelAddress: {
                type: String,
                default: 'Address',
            },
            labelCreatedAt: {
                type: String,
                default: 'Created at',
            },
        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            selectFeature(item) {
                this.$eventBus.publish(this.moduleCode, 'map.select-feature', {'code': item.code, 'item': item, 'detail': true});
                this.$emit('selectFeature', item);
            },
        }
    };
</script>